/**
 * This helper contains analytics origins used by the server. For
 * example: shelved_book_origin.rb
 */

export const ShelvedBookOrigin = {
  BROWSE_SPOTLIGHT: "browse_spotlight",
  RECS_WIDGET: "recs_widget",
};
